<!-- Standard CTA Button Template -->
<ng-template #standardCTAButton let-buttonClasses="buttonClasses">
  @if (!showModal1CTA) {
    <vision-button
      [class]="buttonClasses"
      defaultStyle="tertiary"
      [class.invisible]="!ctaButtonData?.buttonLink"
      [data]="ctaButtonData"
    ></vision-button>
  }
</ng-template>

<!-- Modal 1 CTA Button Template -->
<ng-template #modal1CTAButton let-buttonClasses="buttonClasses" let-extraClasses="extraClasses">
  @if (showModal1CTA) {
    <button
      (click)="activateModal(data.highlightedTextModal1[0].modalContent)"
      class="{{ctaButtonData.buttonStyle}}-button top-product__modal-cta v-button font-bold mt-0 {{buttonClasses}} {{extraClasses}}"
      [class.cursor-pointer]="data.highlightedTextModal1[0].modalContent"
      [class.mr-v-spacing]="useRightMargin"
      >
      {{ ctaButtonData.buttonText }}
    </button>
  }
</ng-template>

<!-- Modal 2 CTA Button Template -->
<ng-template #modal2CTAButton let-buttonClasses="buttonClasses">
  @if (showModal2CTA) {
    <button
      (click)="activateModal(data.highlightedTextModal2[0].modalContent)"
      class="{{secondButtonData.buttonStyle}}-button top-product__modal-cta v-button w-full md:max-w-max md:w-max font-bold mt-0 {{buttonClasses}}"
      [class.xl:ml-3]="showModal1CTA"
      [class.cursor-pointer]="data.highlightedTextModal2[0].modalContent"
      >
      {{ secondButtonData.buttonText }}
    </button>
  }
</ng-template>

<!-- Second Button Template -->
<ng-template #secondCTAButton let-buttonClasses="buttonClasses">
  @if (!showModal2CTA && !isWebinarScheduleLink) {
    <vision-button
      [class]="buttonClasses"
      defaultStyle="tertiary"
      [data]="secondButtonData"
    ></vision-button>
  }
</ng-template>

<!-- Webinar Button Template -->
<ng-template #webinarButton let-buttonClasses="buttonClasses">
  @if (showScheduleCTA) {
    <vision-button
      (click)="showWebinarSchedule($event, data.webinarData)"
      [class]="buttonClasses"
      defaultStyle="tertiary"
      [data]="webinarButtonData"
    ></vision-button>
  }
</ng-template>

<!-- Guarantee Link Template -->
<ng-template #guaranteeLink let-buttonClasses="buttonClasses" let-conditionalCheck="conditionalCheck">
  @if (!data.hideGuaranteeLink && (conditionalCheck === undefined || conditionalCheck)) {
    <button
      (click)="activateModal(data.modalContent)"
      class="tertiary-button top-product__modal-cta font-bold mt-0 ml-0 pt-3 {{buttonClasses}}"
      [class.cursor-pointer]="data.modalContent"
      >
      {{ moneyGuaranteeLabel }}
    </button>
  }
</ng-template>

<!-- Main component -->
@if (showFirstButtonOnly) {
  <div class="{{ outerButtonAlign }}">
    <div class="mb-3 md:mb-v-spacing mt-v-spacing vision-button-container" #topSectionCta>
      <!-- Standard CTA -->
      <ng-container
        *ngTemplateOutlet="standardCTAButton; context: { buttonClasses: 'primary-cta' }">
      </ng-container>
      <!-- Modal 1 CTA -->
      <ng-container
        *ngTemplateOutlet="modal1CTAButton; context: { buttonClasses: 'w-full md:w-max ml-0' }">
      </ng-container>
    </div>
    @if (modalHasContent) {
      <div
            class="flex sm:flex-row flex-col w-max self-center {{
                outerButtonAlign.length > 0 &&
                'xl:self-center md:justify-self-start justify-self-center sm:ml-3 whitespace-nowrap'
            }}"
        >
        <ng-container
          *ngTemplateOutlet="guaranteeLink; context: { buttonClasses: 'border-b-2' }">
        </ng-container>
      </div>
    }
  </div>
}
@if (secondButtonData) {
  <div class="{{ outerButtonAlign }} my-v-spacing vision-button-container dual-button" #topSectionCta>
    <!-- Standard CTA -->
    <ng-container
      *ngTemplateOutlet="standardCTAButton; context: { buttonClasses: (hasSecondButtonData || showModal2CTA) ? 'lg:mb-3 xl:mb-0 sm:mr-3 mb-3 half-container' : '' }">
    </ng-container>
    <!-- Modal 1 CTA -->
    <ng-container
      *ngTemplateOutlet="modal1CTAButton; context: { buttonClasses: 'w-full md:max-w-max md:w-max', extraClasses: modalHasContent ? 'mb-3 md:mb-0 lg:mb-3 xl:mb-0' : '' }">
    </ng-container>
    <!-- Second CTA -->
    <ng-container
      *ngTemplateOutlet="secondCTAButton; context: { buttonClasses: modalHasContent ? 'mb-3 md:mb-0 lg:mb-3 xl:mb-0 half-container' : '' }">
    </ng-container>
    <!-- Modal 2 CTA -->
    <ng-container
      *ngTemplateOutlet="modal2CTAButton; context: { buttonClasses: modalHasContent ? 'mb-3 md:mb-0 lg:mb-3 xl:mb-0' : '' }">
    </ng-container>
    <!-- Webinar CTA - This will be displayed only if webinarData is available -->
    <ng-container
      *ngTemplateOutlet="webinarButton; context: { buttonClasses: '' }">
    </ng-container>
    @if (modalHasContent) {
      <div
        class="flex sm:flex-row flex-col xl:justify-start lg:self-start md:justify-self-start self-center justify-center  md:justify-start items-center {{
            outerButtonAlign.length > 0 && 'self-center md:mt-3 xl:ml-3 lg:ml-0 md:ml-3 whitespace-nowrap'
        }}"
        [class.w-full]="outerButtonAlign.includes('flex-wrap')"
        [class.w-max]="!outerButtonAlign.includes('flex-wrap')"
        >
        <ng-container
          *ngTemplateOutlet="guaranteeLink; context: { buttonClasses: 'w-max', conditionalCheck: !(this.wistiaButtonData?.wistiaId && this.ctaButtonData) }">
        </ng-container>
      </div>
    }
  </div>
}
@if (wistiaButtonData) {
  <div class="{{ outerButtonAlign }} my-v-spacing vision-button-container wistia-button" #topSectionCta>
    <!-- Standard CTA -->
    <ng-container
      *ngTemplateOutlet="standardCTAButton; context: { buttonClasses: 'mb-3 sm:mb-0 sm:mr-3' }">
    </ng-container>
    <!-- Modal 1 CTA -->
    <ng-container
      *ngTemplateOutlet="modal1CTAButton; context: { buttonClasses: 'w-full md:w-max font-bold mt-0 ml-0', extraClasses: wistiaButtonData?.wistiaId ? 'md:mr-3 lg:mr-0 xl:mr-3' : '' }">
    </ng-container>
    <div class="wistia-wrapper">
      @if (this.wistiaButtonData.wistiaId) {
        <vision-video-button
          (click)="ctaVideoPlay($event)"
          class="block mt-3 md:mt-0 lg:mt-3 xl:mt-0 videoCta-{{ this.wistiaCtaData?.wistiaId }}"
          defaultStyle="secondary"
          [data]="wistiaButtonData"
          >
        </vision-video-button>
      }
    </div>
    @if (modalHasContent) {
      <div
        class="flex sm:flex-row flex-col {{
            outerButtonAlign.length > 0 &&
            'xl:justify-self-start lg:justify-self-center md:justify-self-start self-center lg:self-start justify-center items-center md:justify-start whitespace-nowrap'
        }}"
        [class.w-full]="outerButtonAlign.includes('flex-wrap')"
        [class.w-max]="!outerButtonAlign.includes('flex-wrap')"
        >
        <ng-container
          *ngTemplateOutlet="guaranteeLink; context: { buttonClasses: 'flex mt-4 ml-0 sm:ml-v-spacing pt-3 w-max' }">
        </ng-container>
      </div>
    }
  </div>
}
